import React from 'react';
import '../style/formGroupRadioInput.css'

const FormGroupRadioInput = (props) => {
    const {label, options, leftWrapper, inputWrapper, value, name, onChange} = props;
    return (
        <div className="form-group">
            {label && (
                <div className={leftWrapper}>
                    <label className="control-label.text-left formGroupRadioInput-label">{label}</label>
                </div>
            )}
            <div className={inputWrapper}>
                {
                    options.map(option => (
                        <div className="radio" key={option.key}>
                            <label className={'formGroupRadioInputOption'}>
                                <input
                                    onChange={onChange}
                                    type="radio"
                                    name={name}
                                    value={option.key}
                                    checked={option.key === value}
                                />
                                {option.label}
                            </label>
                        </div>
                    ))
                }
            </div>
        </div>
    )
};

export default FormGroupRadioInput;

